import moment from 'moment';

export default {
    methods: {
        unix2date(value) {
            if (!value) return value;
            return moment.unix(value).format('MM/DD/YYYY HH:mm');
        },
        rounddec_2(value) {
            if (!value) return value;
            return 0 + parseFloat(parseFloat(value).toFixed(2));
        },
        push_unique(array, item) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            }
            return array;
        },
        check_progress(amount, complete) {
            return complete;
        },
        ltrim0(stringToTrim) {
            return stringToTrim.replace(/^0+/, '');
        },
    },
};
